<template>
  <div class="col-sm-6 col-xl-3 box-col-3" v-for="(item,index) in items" :key="index">
    <div class="card">
      <div class="blog-box blog-grid">
        <div class="blog-wrraper"><router-link to="/blog/single"><img class="img-fluid top-radius-blog" :src="getImageUrl(item.image)" alt=""></router-link></div>
        <div class="blog-details-second">
          <div class="blog-post-date"><span class="blg-month">apr</span><span class="blg-date">10</span></div><router-link to="/blog/single">
            <h6 class="blog-bottom-details">{{ item.title }}</h6></router-link>
          <p>{{ item.desc }}</p>
          <div class="detail-footer"> 
            <ul class="sociyal-list">
              <li><i class="fa fa-user-o"></i>admin</li>
              <li><i class="fa fa-comments-o"></i>5</li>
              <li><i class="fa fa-thumbs-o-up"></i>2 like</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  
              
</template>
<script>
export default {
  data(){
    return{
      items:[{id:1, title:"Dressing is a way of life.", desc:"A huge part of it is the incomparable beauty you can encounter every day.People just don't do it anymore profound.", image:"blog-5.jpg"},
      {id:1, title:"Encounter every day.", desc:"People just don't do it anymore. We have to change that. Sometimes the simplest things are the most profound.", image:"blog-6.jpg"},
      {id:1, title:"Dressing is a way of life.", desc:"A huge part of it is the incomparable beauty you can encounter every day.People just don't do it anymore profound.", image:"blog-5.jpg"},
      {id:1, title:"Encounter every day.", desc:"People just don't do it anymore. We have to change that. Sometimes the simplest things are the most profound.", image:"blog-6.jpg"},
      ]
    }
  },
  methods: {
    getImageUrl(path) {
      return require("../../../assets/images/blog/" + path);
    },
  },
}
</script>